export const useGeneratedSongUrl = (apiEndpoint: string) => {
  const getFileUrlByName = async (fileName: string) => {
    const resp = await fetch(
      apiEndpoint +
        new URLSearchParams({
          fileName: fileName,
        }),
    );
    if (resp.status === 200) {
      return await resp.text();
    }
    return undefined;
  };

  return {
    getFileUrlByName,
  };
};
